(function () {
  'use strict';

  var section = document.querySelector('.product-grid-section');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var collectionUrl = section.dataset.collectionUrl || window.location.pathname;
  var isLoading = false;
  var priceTimer; // module-scope so it survives sidebar swaps

  // --- DOM helpers ---

  function swapElement(id, doc) {
    var newEl = doc.getElementById(id);
    var oldEl = document.getElementById(id);
    if (newEl && oldEl) oldEl.replaceWith(newEl);
  }

  function showSkeleton() {
    var results = document.getElementById('pg-results');
    if (!results) return;
    var count = Math.max(results.querySelectorAll('.product-card').length, 4);
    var cards = '';
    for (var index = 0; index < count; index++) {
      cards += '<div class="product-card product-card--skeleton">'
        + '<div class="product-card__image-wrap"></div>'
        + '<div class="product-card__info">'
        + '<div class="skeleton-line skeleton-line--title"></div>'
        + '<div class="skeleton-line skeleton-line--price"></div>'
        + '</div></div>';
    }
    results.innerHTML = '<div class="product-grid">' + cards + '</div>';
  }

  // --- URL building ---

  function buildUrl(formEl, sortValue) {
    var url = new URL(collectionUrl, window.location.origin);

    if (formEl) {
      new FormData(formEl).forEach(function (val, key) {
        if (val !== '') url.searchParams.append(key, val);
      });

      // Price inputs have no name (excluded from FormData); add manually
      formEl.querySelectorAll('[data-price-param]').forEach(function (input) {
        var param = input.getAttribute('data-price-param');
        if (input.value === '') return;
        var val = parseFloat(input.value);
        if (val > 0) url.searchParams.set(param, val);
      });
    }

    if (sortValue !== undefined) {
      url.searchParams.set('sort_by', sortValue);
    } else if (!url.searchParams.has('sort_by')) {
      var cur = new URLSearchParams(window.location.search).get('sort_by');
      if (cur) url.searchParams.set('sort_by', cur);
    }

    return url;
  }

  // --- AJAX fetch + swap ---

  function applyFilters(url, pushState) {
    if (isLoading) return;
    clearTimeout(priceTimer);
    isLoading = true;
    section.classList.add('is-loading');
    showSkeleton();

    var fetchUrl = new URL(url.toString());
    fetchUrl.searchParams.set('sections', sectionId);

    fetch(fetchUrl.toString())
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');

        swapElement('pg-count', doc);
        swapElement('pg-active-filters', doc);
        swapElement('pg-sidebar', doc);
        swapElement('pg-results', doc);

        if (pushState !== false) history.pushState(null, '', url.toString());

        initSidebarListeners();
        initPriceListeners();
      })
      .catch(function () {})
      .finally(function () {
        isLoading = false;
        section.classList.remove('is-loading');
      });
  }

  // --- Sidebar listeners (re-attached after each swap) ---

  function getSidebarForm() {
    return document.querySelector('#pg-sidebar form');
  }

  function initSidebarListeners() {
    document.querySelectorAll('#pg-sidebar .js-sort-radio').forEach(function (radio) {
      radio.addEventListener('change', function () {
        applyFilters(buildUrl(getSidebarForm(), this.value));
      });
    });

    var form = getSidebarForm();
    if (form) {
      form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          applyFilters(buildUrl(getSidebarForm()));
        });
      });
    }
  }

  // --- Price inputs (re-attached after each sidebar swap) ---

  function initPriceListeners() {
    document.querySelectorAll('#pg-sidebar .js-price-input').forEach(function (input) {
      input.addEventListener('input', function () {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(function () {
          applyFilters(buildUrl(getSidebarForm()));
        }, 800);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          clearTimeout(priceTimer);
          applyFilters(buildUrl(getSidebarForm()));
        }
      });
    });
  }

  // --- Filter modal ---

  var modal = document.getElementById('filter-modal');
  var openBtn = document.querySelector('.js-filter-open');

  if (openBtn && modal) {
    openBtn.addEventListener('click', function () {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    });
  }

  document.querySelectorAll('.js-filter-close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });
  });

  var modalForm = document.querySelector('.filter-modal__body');
  if (modalForm) {
    modalForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters(buildUrl(this));
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // --- Delegation: pagination + active filter badges + clear all ---
  // Attached to section (never replaced), so survives DOM swaps.

  section.addEventListener('click', function (event) {
    var paginationLink = event.target.closest('#pg-results .pagination__btn, #pg-results .pagination__page[href]');
    if (paginationLink) {
      event.preventDefault();
      applyFilters(new URL(paginationLink.href));
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var filterBadge = event.target.closest('#pg-active-filters a');
    if (filterBadge) {
      event.preventDefault();
      applyFilters(new URL(filterBadge.href));
      return;
    }

    var modalClear = event.target.closest('.filter-modal__footer a[href]');
    if (modalClear) {
      event.preventDefault();
      applyFilters(new URL(modalClear.href));
      if (modal) {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    }
  });

  // --- Back / forward navigation ---

  window.addEventListener('popstate', function () {
    applyFilters(new URL(window.location.href), false);
  });

  // --- Init ---

  initSidebarListeners();
  initPriceListeners();
})();
